import { render, staticRenderFns } from "./LoadingContained.vue?vue&type=template&id=43be7f7c&"
import script from "./LoadingContained.vue?vue&type=script&lang=js&"
export * from "./LoadingContained.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports